import Backbone from 'backbone';
import _ from 'underscore';
import {COMPLETE, ERROR, SUCCESS} from 'common/constants';

Backbone.$ = $;

let collectionsFetched = 0;
let collectionsToFetch = 0;
let promise = {};
let xhrs = [];

export const abort = () => {
  for (let ii = 0, nn = xhrs.length; ii < nn; ii++) {
    if (xhrs[ii] && xhrs[ii].hasOwnProperty('abort')) {
      xhrs[ii].abort();
    }
  }
  xhrs = [];
};

export const removeListeners = () => {
  if (promise.hasOwnProperty('collections')) {
    const collections = promise.collections;
    for (let ii = 0, nn = collections.length; ii < nn; ii++) {
      const collection = collections[ii];
      collection.off(ERROR);
      collection.off(SUCCESS);
    }
  }
};

export const setCounters = (collections) => {
  collectionsFetched = 0;
  collectionsToFetch = collections.length;
};

export const setPromise = (collections) => {
  promise = _.extend({collections}, Backbone.Events);
};

export const onFetchError = (event, response, options) => {
  collectionsFetched++;
  removeListeners();
  promise.trigger(ERROR, {target: event.target}, response, options);
};

export const onFetchSuccess = (collection, response, options) => {
  collectionsFetched++;
  if (collectionsFetched === collectionsToFetch) {
    removeListeners();
    promise.trigger(COMPLETE, {target: promise}, response, options);
  }
};

export const fetchCollections = (params, collections) => {
  removeListeners();
  abort();
  setCounters(collections);
  setPromise(collections);
  for (let ii = 0, nn = collections.length; ii < nn; ii++) {
    const collection = collections[ii];
    collection.on(ERROR, onFetchError, this);
    collection.on(SUCCESS, onFetchSuccess, this);
    if ($.isArray(params)) {
      xhrs.push(collection.fetchJSON(params[ii]));
    } else {
      xhrs.push(collection.fetchJSON(params));
    }
  }
  return promise;
};
